import { RuleEvent } from '@app/models/rules';

export class RuleValidator {
    
    isValid(rule: RuleEvent) : boolean {
        // check conditions empty for tags: 
        let validConds = true;
        rule.conditions.forEach((c) => {
            if ( c.value == '')
                validConds = false;
        });

        return rule.name != "" && rule.key != "" && rule.actions.length > 0 && validConds;
    }
}